import JobType from '__core/shared/model/job/JobType';
import jobTypesController from './jobTypes.controller';
import stJobTypesList from './jobTypesList.component';

export default angular
  .module('st.JobType', ['st.Core', 'st.Job', 'angular-cache'])
  .factory('JobType', () => JobType)
  .service('jobTypeService', (JobType, dataService) => ({
    createJobType: (doc) => dataService.createDocument(JobType, doc),
    readJobType: (doc) => dataService.readDocument(JobType, doc),
    updateJobType: (doc) => dataService.updateDocument(JobType, doc),
    deleteJobType: (doc) => dataService.deleteDocument(JobType, doc)
  }))
  .controller('jobTypesController', jobTypesController)
  .component('stJobTypesList', stJobTypesList)
  .service(
    'jobTypesService',
    ($http, $rootScope, CacheFactory, dataService, JobType, JOBTYPE) => {
      let cache;
      if (!CacheFactory.get(JOBTYPE.CACHE.NAME)) {
        cache = CacheFactory(JOBTYPE.CACHE.NAME, JOBTYPE.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || JOBTYPE.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params),
            params?.ignoreCache === true,
            JobType.build,
            $http.get,
            JOBTYPE.API.AVAILABLE,
            { params }
          )
      };
    }
  )
  .constant('JOBTYPE', {
    API: {
      AVAILABLE: '/api/v1/jobtypes/available/'
    },
    CACHE: {
      NAME: 'jobTypesCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
